import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'type-socio',
  templateUrl: './type-socio.component.html',
  styleUrls: ['./type-socio.component.css']
})
/** typeSocio component*/
export class TypeSocioComponent implements OnInit {


  @Input() entita: any;

  @Input() size: number = 1;

  classFont: string;

  /** typeSocio ctor */
  constructor() {
  }

  ngOnInit(): void {

    if (!this.entita.tipo) {
      this.classFont = '';
      return;
    }
    switch (this.entita.tipo) {
      case 2:
        this.classFont = `fas fa-paw fa-${this.size}x`;
        return;

      case 1:
        {
          if (this.entita.natoIl) {
            let timeDiff = Math.abs(Date.now() - this.entita.natoIl);
            let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);

            if (age < 18) {
              this.classFont = `fas fa-child fa-${this.size}x`;
            } else if (this.entita.sesso && this.entita.sesso == 'F') {
              this.classFont = `fas fa-female fa-${this.size}x`;
            } else {
              this.classFont = `fas fa-male fa-${this.size}x`;
            }
          } else {
            this.classFont = '';
          }
          return;
        }
    }

    this.classFont = '';
  }
}
